export function getProjectTableRowKey(record = {}) {
    const key = record.project_id ?? record.id ?? record.generated_id;
    return key === undefined || key === null ? "" : String(key);
}
